export { DashboardResolver } from './dashboard.resolver';
export { DeviceResolver } from 'src/app/core/resolver/device-resolver.service';
export { SiteResolver } from './site-resolver.service';
